import { getPageByUrl } from "@/services/pagesService";
import CreatePage from "@/admin/helpers/pageCreator/PageCreator";
import { NextSeo } from 'next-seo';
import { useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';
import { useEffect, useState, useCallback, useMemo } from "react";
import { useRouter } from 'next/router';
import Error from 'next/error';

export async function getStaticProps() {
  try {
    const res = await getPageByUrl("index");
    const pageData = res ?? null;

    return {
      props: {
        pageData
      }
    };
  } catch (error) {
    return {
      props: {
        pageData: null
      }
    };
  }
}

export default function Index({ pageData: initialPageData }: any) {
  const { i18n } = useTranslation();
  const router = useRouter();
  const dispatch = useDispatch();
  const [pageData, setPageData] = useState(() => initialPageData);
  const [isLoading, setIsLoading] = useState(false);

  const handleStart = useCallback(() => setIsLoading(true), []);
  const handleComplete = useCallback(() => setIsLoading(false), []);
  const handleError = useCallback(() => setIsLoading(false), []);

  useEffect(() => {
    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleComplete);
    router.events.on('routeChangeError', handleError);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleComplete);
      router.events.off('routeChangeError', handleError);
    };
  }, [router.events, handleStart, handleComplete, handleError]);

  const fetchPageData = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await getPageByUrl("index", "");
      
      if (res && res !== 404) {
        setPageData(res);
        if (res.data) {
          
            dispatch.currentPageModel.setUrls('');
            dispatch.currentPageModel.setImagePress(res.data.pressNew?.imgSrc);
            dispatch.currentPageModel.setTitle(
              res.data.title[res.data.languge] ?? res.data.title[i18n.language]
            );
            const imagePage = res.data.pressNew?.imgSrc || 
                             res.data.post?.imgSrc || 
                             res.data.post_articale?.imgSrc || 
                             res.data.metaImage;
            dispatch.currentPageModel.setImage(imagePage);
          
        }
      }
    } catch (error) {
      console.error('Error fetching page data:', error);
    } finally {
      setIsLoading(false);
    }
  }, [dispatch, i18n.language]);

  useEffect(() => {
    if (!router.isReady) return;
    fetchPageData();
  }, [router.isReady, fetchPageData]);

  const pageTitle = useMemo(() => 
    pageData?.data?.title[i18n.language] ?? pageData?.data?.title,
    [pageData?.data?.title, i18n.language]
  );

  const imagePage = useMemo(() => 
    pageData?.data?.pressNew?.imgSrc || 
    pageData?.data?.post?.imgSrc || 
    pageData?.data?.metaImage,
    [pageData?.data]
  );

  const pageDescription = useMemo(() => 
    pageData?.data?.description
      ? pageData?.data?.description[i18n.language]
      : pageData?.data?.description,
    [pageData?.data?.description, i18n.language]
  );

  // Show loading state


  // Show 404 for non-existent pages
  if (!pageData || pageData === 404) {
    return <Error statusCode={404} title="Page Not Found" />;
  }

  return (
    <>
      <NextSeo
        title={pageTitle}
        description={pageDescription}
        canonical={`https://masdemonpere.com${router.asPath}`}
        openGraph={{
          locale: i18n.language,
          images: [
            {
              url: imagePage,
              width: 342,
              height: 513,
              alt: pageTitle,
            },
            {
              url: imagePage,
              width: 1280,
              height: 720,
              alt: pageTitle,
            },
          ],
        }}
      />
      {pageData && CreatePage(pageData?.data?.content ?? null)}
    </>
  );
}
